import React, { Component } from "react";
// reactstrap components
import { FormGroup, Label, Input } from "reactstrap";

export default class SingleToggle extends Component {
  displayError() {
    const error = this.props.error;
    if (typeof error != "undefined" && error != null) {
      return <div className='text-danger'>{error.text}</div>;
    }
  }

  render() {
    return (
      <FormGroup className='custom-control custom-checkbox mb-3'>
        <Input
          type={"checkbox"}
          className='custom-control-input'
          id={this.props.name}
          name={this.props.name}
          checked={this.props.currentValue}
          onChange={(e) => {
            console.log("toggled to: ", e.target.checked);
            this.props.handleChange(this.props.name, e.target.checked);
          }}
        />
        <Label className='custom-control-label' htmlFor={this.props.name}>
          {this.props.label}
        </Label>
        {this.displayError()}
      </FormGroup>
    );
  }
}
